import { ButtonProps } from '@mui/material';
import { EmulatorType, PlanFamily } from '@localstack/types';
import { EMULATOR_LABELS } from '@localstack/constants';
import { MouseEvent, ReactElement } from 'react';

import { ButtonWithDialog } from '../../../feedback/ButtonWithDialog';
import { StartPreviewLegalFineprint, StartTrialLegalFineprint } from '../../../display';

type Props = Omit<ButtonProps, 'onClick'> & {
  /** The product being started; drives the dialog title. */
  emulator: EmulatorType;
  /** Label for both the trigger and the confirm button. */
  buttonText?: string;
  /** The family being started; a preview is joined rather than trialled. */
  family?: PlanFamily;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
};

export const StartPlanButton = ({
  emulator,
  buttonText = 'Start trial',
  family = PlanFamily.TRIAL_PLANS,
  onClick,
  ...rest
}: Props): ReactElement => (
  <ButtonWithDialog
    componentType="Button"
    variant="outlined"
    dialogTitle={
      family === PlanFamily.PREVIEW_PLANS
        ? `Join the LocalStack for ${EMULATOR_LABELS[emulator]} Public Preview`
        : `Start your free LocalStack for ${EMULATOR_LABELS[emulator]} Trial`
    }
    dialogContent={family === PlanFamily.PREVIEW_PLANS ? <StartPreviewLegalFineprint /> : <StartTrialLegalFineprint />}
    confirmButtonText={buttonText}
    onClick={onClick}
    {...rest}
  >
    {buttonText}
  </ButtonWithDialog>
);
